<ngb-datepicker #dp (select)="onDateSelection($event)" [markDisabled]="isDisabled" [dayTemplate]="t"></ngb-datepicker>

<ng-template #t let-date="date" let-focused="focused">
  <span class="custom-day"
    [class]="date | dayClasses:eventGroups"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>
